SupportAPIHelper = require('../../helpers/API')
SupportGiftOrderPopupFormTemplate = require('../../../gift_order_popup_form.html.mustache')
Backbone = require 'backbone'
Backbone.$ = $

class SupportGiftOrderPopupView extends Backbone.View
  id: 'giftpopupContent'

  initialize: (options) ->
    @options = options || {}
    _.bindAll.apply(_, [this].concat(_.functions(this)))
    @I18nScope = 'modules.support'
    @template = SupportGiftOrderPopupFormTemplate
    @order = Groupon.Support.currentOrder
    @attributes = @options.userId
    @isEmail = true;
    @render()

  render: ->
    @popup = $('#popup')
    GIG.Modal.open
      el: @popup
      closeOnBgClick: true
      closeOnEscKey: true
    @popup.html toHtml(@template, {}, @I18nScope)
    @giftEmailDeliveryType = $('#emailType')
    @saveBtn = $('#gift_details_save_btn')
    @recipientName = $('#order_gift_recipient_name')
    @senderName = $('#order_gift_from_name')
    @recipientEmail = $('#order_gift_recipient_email')
    @message = $('#order_gift_message')
    @giftEmailDeliveryType.prop('checked', true)
    @validateToField = $('#validate_to_field')
    @validateFromField = $('#validate_from_field')
    @validateEmail = $('#validate_email')
    @saveBtn.bind("click", @saveBtnHandler)
    $("input:radio[name=deliveryType]").click (ev)->
      emailInput = $('#order_gift_recipient_email')
      if ev.currentTarget.id is "emailType"
        @isEmail = true
        emailInput.removeAttr 'disabled'
      else
        @isEmail = false
        emailInput.val("")
        emailInput.prop 'disabled', 'disabled'
    $('#order_gift_message').keyup (ev) ->
      max = 330
      msgDiv =  $('#order_gift_message')
      content = msgDiv.val()
      if content.length >= max
        remaining = 0
        $('#noOfChars').text(remaining + " characters")
      else
        remaining = max - content.length
        if remaining == 1
          $('#noOfChars').text(remaining + " character")
        else
          $('#noOfChars').text(remaining + " characters")

  clearValidationMessages: ->
    @validateToField.text('')
    @validateFromField.text('')
    @validateEmail.text('')

  validate: ->
    validationPass = true
    @clearValidationMessages()
    if @recipientName.val().length == 0
      @validateToField.text('Field cannot be empty')
      validationPass = false

    if @senderName.val().length == 0
      @validateFromField.text('Field cannot be empty')
      validationPass = false

    if @isEmail == true
      email = @recipientEmail.val()
      unless @validateEmailAddress email
        @validateEmail.text('Enter valid email address')
        validationPass = false

    validationPass

  validateEmailAddress: (email) ->
    re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    re.test(email)

  saveBtnHandler: ->
    unless @validate()
      return
    successCallback = @closePopup
    errorCallback = @renderErrorPage
    data = {}
    data.module_name = 'contact_us_ajax'
    data.method_name = 'giftOrder'
    options ={}
    options.gift_to_name= @recipientName.val()
    options.gift_from_name = @senderName.val()
    if @isEmail == true
      options.gift_recipient_email_address = @recipientEmail.val()
      options.gift_delivery_method = "email"
    else
      options.gift_delivery_method = "print"

    options.gift_message = @message.val()
    options.order_id = Groupon.Support.currentOrder.id
    options.deal_id = Groupon.Support.currentOrder.deal.id

    url = "#{window.SUPPORTBASEURL}/getData"
    data = {}
    data.module_name = "orders_update"
    data.method_name = "giftOrder"
    data.options = options
    SupportAPIHelper.get url, data, successCallback, errorCallback, true

  renderErrorPage: ->
    flash('error', "Error when contacting server for gift order action")

  closePopup: ->
    GIG.Modal.close()
    return false

  events:
    "click #gift_details_cancel_btn" : "closePopup"

module.exports = SupportGiftOrderPopupView
